<script lang="ts">
    import MultiSelectWideAsync from '../../../shared/MultiSelectWideAsync.svelte';
    import type { Entry } from '../../../components/telematics/components/MultiSelectWide/types';
    import MultiSelectWide from '../../../shared/MultiSelectWide.svelte';

    // Przykładowe dane - miasta europejskie
    const europeanCities: Entry[] = [
        { id: 'warsaw', name: 'Warsaw' },
        // { id: 'berlin', name: 'Berlin' },
        { id: 'paris', name: 'Paris' },
        { id: 'london', name: 'London' },
        { id: 'madrid', name: 'Madrid' },
        { id: 'rome', name: 'Rome' },
        { id: 'vienna', name: 'Vienna' },
        { id: 'prague', name: 'Prague' },
        { id: 'amsterdam', name: 'Amsterdam' },
        { id: 'brussels', name: 'Brussels' },
        { id: 'budapest', name: 'Budapest' },
        { id: 'stockholm', name: 'Stockholm' },
        { id: 'copenhagen', name: 'Copenhagen' },
        { id: 'oslo', name: 'Oslo' },
        { id: 'helsinki', name: 'Helsinki' },
        { id: 'dublin', name: 'Dublin' },
        { id: 'lisbon', name: 'Lisbon' },
        { id: 'athens', name: 'Athens' },
        { id: 'bucharest', name: 'Bucharest' },
        { id: 'sofia', name: 'Sofia' },
    ];

    // Symulowana funkcja loadOptions z opóźnieniem 1 sekundy
    async function loadOptions(searchQuery: string): Promise<Entry[]> {
        console.log('loadOptions called with query:', searchQuery);

        // Symulacja opóźnienia 1 sekundy
        await new Promise(resolve => setTimeout(resolve, 1000));

        // Filtrowanie na podstawie query (case-insensitive)
        if (!searchQuery) {
            return europeanCities;
        }

        const lowerQuery = searchQuery.toLowerCase();
        return europeanCities.filter(city =>
            city.name.toLowerCase().includes(lowerQuery)
        );
    }

    let selectedIds: string[] = ['warsaw', 'berlin'];
</script>

<div style="display: flex; flex-direction: column; gap: 20px;">
    <h2>Multi Select Wide Async Example</h2>
    <p>This component loads options asynchronously with a 1-second delay.</p>

    <MultiSelectWideAsync
        loadOptions={loadOptions}
        selectedIds={selectedIds}
        disabled={false}
        minAllowedSelectedItems={0}
        onChange={newSelectedIds => {
            console.log('MultiSelectWideAsync onChange', newSelectedIds);
            // selectedIds = newSelectedIds;
        }}
    />

    <MultiSelectWide
        availableEntries={europeanCities}
        selectedIds={selectedIds}
        disabled={false}
        minAllowedSelectedItems={0}
        onChange={newSelectedIds => {
            console.log('MultiSelectWideAsync onChange', newSelectedIds);
            // selectedIds = newSelectedIds;
        }}
    />
</div>